import React from 'react';
import { Star, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';

const GOOGLE_REVIEWS_URL = 'https://maps.app.goo.gl/3ssm3YBHfBfcYC8s5';

// Reviews section: links to genuine Google reviews only (no hard-coded quotes).
const Testimonials = () => (
  <section className="py-12 bg-gradient-to-br from-emerald-50 to-white" data-testid="reviews-section">
    <div className="container mx-auto px-4">
      <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-3 text-center">
        Avis clients
      </h2>
      <p className="text-center text-gray-600 mb-8 max-w-xl mx-auto">
        Les avis de mes clients sont publiés directement sur ma fiche Google.{' '}
        <a
          href={GOOGLE_REVIEWS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="text-emerald-600 hover:text-emerald-700 font-medium"
          data-testid="reviews-see-google-link"
        >
          Voir les avis Google →
        </a>
      </p>
      <div className="text-center bg-white rounded-xl p-6 max-w-xl mx-auto border border-gray-200">
        <p className="text-gray-700 mb-4">
          Vous voulez laisser un retour ? Je serais ravi d'avoir votre avis !
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a href={GOOGLE_REVIEWS_URL} target="_blank" rel="noopener noreferrer" data-testid="reviews-leave-google-link">
            <Button className="bg-emerald-600 hover:bg-emerald-700 text-white">
              <Star className="mr-2" size={16} />
              Laisser un avis Google
            </Button>
          </a>
          <a href="https://wa.me/33782586685" target="_blank" rel="noopener noreferrer" data-testid="reviews-whatsapp-link">
            <Button variant="outline" className="border-emerald-500 text-emerald-600 hover:bg-emerald-50">
              <MessageCircle className="mr-2" size={16} />
              M'envoyer un message
            </Button>
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default Testimonials;
